import {Inject, Injectable} from '@angular/core';
import { SecureApi } from '../../core/secure.api';

@Injectable()
export class MePackageService {

    public TYPE = {
        MAP: 'Map',
        COMBINED: 'Combined',
        APPOINTMENT: 'Appointment',
        APPOINTMENTWITHDISCOUNT: 'AppointmentWithDiscount'
    };

    public STATUS = {
        NOSHOW: 'NoShow',
    };

    constructor(
       private secureApi : SecureApi
    ) {

    }
}
